const comments = [
  {
    name: '漫画迷小陈',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20portrait%20of%20a%20young%20Asian%20person%20with%20warm%20smile%2C%20soft%20pastel%20background%2C%20simple%20circle%20avatar%20style%2C%20clean%20minimal%20illustration&width=120&height=120&seq=avatar-cmt-01&orientation=squarish',
    text: '亲亲漫画网的下拉式阅读真的太爽了！以前翻页总被打断，现在一口气能看几十话，韩漫全彩效果也特别好，画质清晰不压缩。追更更新速度也快，每天都有新内容，已经推荐给身边所有漫友了！',
    time: '2小时前',
    tag: '忠实读者',
  },
  {
    name: '二次元阿星',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20anime%20style%20portrait%20of%20a%20smiling%20person%2C%20soft%20orange%20background%2C%20simple%20circle%20avatar%2C%20friendly%20expression%2C%20clean%20minimal%20illustration&width=120&height=120&seq=avatar-cmt-02&orientation=squarish',
    text: '日漫资源真的太全了，好多小众作品在这里都能找到。下拉式设计的漫画阅读方式很舒适，手机上看一点也不累。而且完全免费无广告，纯粹看漫画的感觉太好了，会一直支持下去！',
    time: '5小时前',
    tag: '日漫爱好者',
  },
  {
    name: '追漫小鹿',
    avatar: 'https://readdy.ai/api/search-image?query=A%20gentle%20anime%20style%20portrait%20of%20a%20person%20with%20soft%20expression%2C%20light%20peach%20background%2C%20simple%20circle%20avatar%2C%20warm%20minimal%20illustration&width=120&height=120&seq=avatar-cmt-03&orientation=squarish',
    text: '以前用其他漫画平台要一页一页翻，看几话手指就酸了。换了亲亲漫画网之后发现下拉式漫画阅读才是王道，流畅滑动体验超棒，加载速度也快。唯一的"缺点"就是一看就停不下来哈哈！',
    time: '1天前',
    tag: '新用户',
  },
  {
    name: '资深漫画人老张',
    avatar: 'https://readdy.ai/api/search-image?query=A%20mature%20anime%20style%20portrait%20of%20a%20person%20with%20confident%20look%2C%20warm%20brown%20background%2C%20simple%20circle%20avatar%2C%20clean%20minimal%20illustration&width=120&height=120&seq=avatar-cmt-04&orientation=squarish',
    text: '看了十几年漫画，亲亲漫画网是我用过最好的下拉式漫画阅读网站。分类齐全、更新及时、阅读体验一流。下拉式阅读方式完美还原了纸质漫画的连贯感，全集资源丰富，很多绝版老漫都能在这找到。',
    time: '2天前',
    tag: '资深读者',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">读者热评</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            听听广大漫友们对亲亲漫画网下拉式阅读体验的真实评价
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {comments.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70 transition-all duration-300 hover:border-primary-200"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <h3 className="font-heading text-sm font-bold text-foreground-900">{item.name}</h3>
                    <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">{item.tag}</span>
                  </div>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3">
                    {item.text}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-foreground-400">{item.time}</span>
                    <div className="flex items-center gap-1 text-secondary-500">
                      <i className="ri-thumb-up-line text-xs"></i>
                      <span className="text-xs">{thumbsCounts[idx]}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}